import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { KitMockup } from "./KitMockup";
export function Hero() {
  return <section className="hero" id="top" data-id="element-59" data-mp="ei1vfm5pk2xy">
      <div className="shell" data-id="element-60" data-mp="9k0bkz0gjzlf">
        <header className="brand-row" data-id="element-61" data-mp="9l34fchccc3z">
          <a href="#top" aria-label="Customer Service Training Ready, back to top" data-id="element-62" data-mp="4lyv8luf2edn">
            CUSTOMER SERVICE <span data-id="element-63" data-mp="1297ahz3tqr77">TRAINING READY</span>
          </a>
          <a href="#offer-details" className="header-preview" data-id="element-64" data-mp="128z14h6wu40r">
            Get the kit <ArrowRightIcon size={15} aria-hidden="true" data-id="element-65" data-mp="xbfmvha7pr8t" />
          </a>
        </header>
        <div className="hero-center" data-id="element-66" data-mp="sai2qz5n6n4o">
          <h1 data-id="element-67" data-mp="s9ghk1uwwk98">
            Your next 10 customer service
            <br data-id="element-68" data-mp="nczt16jsw3vm" />
            training sessions—<span data-id="element-69" data-mp="nbygsyr1tbcb">already planned.</span>
          </h1>
          <figure className="hero-center-visual" data-id="element-70" data-mp="3d21uc37gquqd">
            <KitMockup data-id="element-71" data-mp="3d2tln1u126au" />
          </figure>
          <div className="hero-center-action" data-id="element-72" data-mp="381xmt2oj9aca">
            <CtaButton href="#offer-details" data-id="element-73" data-mp="3814aznapvuna">
              Get the complete kit — $27 <ArrowRightIcon size={19} aria-hidden="true" data-id="element-74" data-mp="3j9kazboofhg4" />
            </CtaButton>
            <p className="cta-note" data-id="element-75" data-mp="3o7vkflb27pxt">USD · One-time payment · English-language PDFs</p>
          </div>
        </div>
      </div>
    </section>;
}